import { motion } from "framer-motion";
import { Milk, Bone, ArrowUpRight, Link2 } from "lucide-react";

const LACLIVE = "https://laclive.de";

export default function LacLivePartner() {
  return (
    <section id="partner" className="scroll-mt-24 py-20 lg:py-28 bg-[#F3EFE6]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl bg-[#1E3F20] text-white p-8 sm:p-12 fb-grain"
        >
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 text-[#D99B26] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 mb-6">
                <Link2 className="w-3.5 h-3.5" /> Partnerseite
              </span>
              <h2 className="font-display text-3xl sm:text-4xl font-bold leading-tight">
                Milch verträgt sich mit starken Knochen
              </h2>
              <p className="mt-5 text-[#C7D5C4] leading-relaxed">
                Wer Milchprodukte wegen einer Laktoseintoleranz meidet, nimmt oft zu wenig Calcium auf – ein
                Risikofaktor für Knochenschwund. Beide Themen verbindet dasselbe Fundament: ein gesundes
                Darm-Mikrobiom. Unsere Partnerseite <strong className="text-white">LacLive</strong> zeigt
                evidenzbasiert, wie du deine Laktosetoleranz in 12 Wochen wieder aufbaust – und Milch als
                natürliche Calciumquelle zurückgewinnst.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href={LACLIVE}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="laclive-cta-main"
                  className="inline-flex items-center justify-center gap-2 bg-[#D99B26] hover:bg-[#c68b1e] text-[#1E3F20] font-semibold rounded-full px-7 h-12 transition-colors"
                >
                  LacLive entdecken <ArrowUpRight className="w-4 h-4" />
                </a>
                <a
                  href={`${LACLIVE}/mythen-und-fakten`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="laclive-cta-myths"
                  className="inline-flex items-center justify-center gap-2 border border-white/30 hover:bg-white/10 text-white rounded-full px-7 h-12 transition-colors"
                >
                  Mythen zu Laktose
                </a>
              </div>
            </div>

            <div className="flex items-center justify-center gap-6">
              <div className="flex flex-col items-center gap-3">
                <div className="w-20 h-20 rounded-2xl bg-white/10 ring-1 ring-white/15 flex items-center justify-center">
                  <Bone className="w-9 h-9 text-[#D99B26]" />
                </div>
                <span className="text-sm font-semibold text-white">FoodBone</span>
                <span className="text-xs text-[#8FA58C]">Knochen &amp; Ernährung</span>
              </div>
              <div className="text-[#769777] font-display text-3xl">+</div>
              <div className="flex flex-col items-center gap-3">
                <div className="w-20 h-20 rounded-2xl bg-white/10 ring-1 ring-white/15 flex items-center justify-center">
                  <Milk className="w-9 h-9 text-[#D99B26]" />
                </div>
                <span className="text-sm font-semibold text-white">LacLive</span>
                <span className="text-xs text-[#8FA58C]">Laktose &amp; Toleranz</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
